module.exports = __webpack_public_path__ + "static/media/AbstractShapeLeft.8656c9eb.svg";